"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- SINGLESELECTDROPDOWN : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'SingleSelectDropDown',
  group: _definitionhelpers.groupNames.dropdowns,
  props: {
    name: {
      type: 'string',
      default: 'name'
    },
    klass: {
      type: 'string'
    },
    onSelect: {
      type: 'function',
      default: function _default() {
        return console.log('Selected');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    items: {
      type: 'object',
      default: [{
        name: 'As in embed',
        value: 'QUEUE_POSITION',
        dir: 'ASC'
      }, {
        name: 'Date created (newest)',
        value: 'CREATED_AT',
        dir: 'DESC'
      }, {
        name: 'Date created (oldest)',
        value: 'CREATED_AT',
        dir: 'ASC'
      }, {
        name: 'Engagement',
        value: 'ENGAGEMENT',
        dir: 'DESC'
      }]
    },
    selected: {
      type: 'object'
    },
    disabled: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    searchable: {
      type: 'boolean',
      default: true,
      options: [false, true]
    },
    paginated: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    itemsPerPage: {
      type: 'number',
      default: 2
    }
  }
};
exports.default = _default2;